import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './Topbar.module.css';

const MenuIcon = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.rootMenuIcon, className);

  return (
   <svg width="28" height="19" viewBox="0 0 28 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.66667 18.75H26.3333C27.1812 18.75 27.875 18.0562 27.875 17.2083C27.875 16.3604 27.1812 15.6667 26.3333 15.6667H1.66667C0.81875 15.6667 0.125 16.3604 0.125 17.2083C0.125 18.0562 0.81875 18.75 1.66667 18.75ZM1.66667 11.0417H26.3333C27.1812 11.0417 27.875 10.3479 27.875 9.5C27.875 8.65208 27.1812 7.95833 26.3333 7.95833H1.66667C0.81875 7.95833 0.125 8.65208 0.125 9.5C0.125 10.3479 0.81875 11.0417 1.66667 11.0417ZM0.125 1.79167C0.125 2.63958 0.81875 3.33333 1.66667 3.33333H26.3333C27.1812 3.33333 27.875 2.63958 27.875 1.79167C27.875 0.94375 27.1812 0.25 26.3333 0.25H1.66667C0.81875 0.25 0.125 0.94375 0.125 1.79167Z" fill="black"/>
</svg>
   
  );
};

const { string } = PropTypes;

MenuIcon.defaultProps = {
  className: null,
  rootClassName: null,
};

MenuIcon.propTypes = {
  className: string,
  rootClassName: string,
};

export default MenuIcon;
